module.exports = __webpack_public_path__ + "static/img/3.dbb694a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R22/3.jpg
// module id = Uq2w
// module chunks = 1